/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { TeachingTableCtaModel, TeachingTableCtaModelType } from './TeachingTableCtaModel'
import { TeachingTableCtaModelSelector } from './TeachingTableCtaModel.base'
import { TeachingTableGamesStatusEnumType } from './TeachingTableGamesStatusEnum'
import { TeachingTableModel, TeachingTableModelType } from './TeachingTableModel'
import { TeachingTableModelSelector } from './TeachingTableModel.base'
import { RootStoreType } from './index'

/**
 * TeachingTableGameBase
 * auto generated base class for the model TeachingTableGameModel.
 */
export const TeachingTableGameModelBase = ModelBase.named('TeachingTableGame')
  .props({
    __typename: types.optional(types.literal('TeachingTableGame'), 'TeachingTableGame'),
    channelName: types.union(types.undefined, types.null, types.string),
    cta: types.union(
      types.undefined,
      types.null,
      types.late(() => TeachingTableCtaModel)
    ),
    isFull: types.union(types.undefined, types.boolean),
    openSeats: types.union(types.undefined, types.number),
    scheduleId: types.union(types.undefined, types.null, types.string),
    scheduleTime: types.union(types.undefined, types.frozen()),
    status: types.union(types.undefined, TeachingTableGamesStatusEnumType),
    tableAmount: types.union(types.undefined, types.number),
    teachingTable: types.union(
      types.undefined,
      types.late(() => TeachingTableModel)
    ),
    winners: types.union(types.undefined, types.null, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TeachingTableGameModelSelector extends QueryBuilder {
  get channelName() {
    return this.__attr('channelName')
  }
  get isFull() {
    return this.__attr('isFull')
  }
  get openSeats() {
    return this.__attr('openSeats')
  }
  get scheduleId() {
    return this.__attr('scheduleId')
  }
  get scheduleTime() {
    return this.__attr('scheduleTime')
  }
  get status() {
    return this.__attr('status')
  }
  get tableAmount() {
    return this.__attr('tableAmount')
  }
  get winners() {
    return this.__attr('winners')
  }
  cta(
    builder:
      | string
      | TeachingTableCtaModelSelector
      | ((selector: TeachingTableCtaModelSelector) => TeachingTableCtaModelSelector)
      | undefined
  ) {
    return this.__child('cta', TeachingTableCtaModelSelector, builder)
  }
  teachingTable(
    builder:
      | string
      | TeachingTableModelSelector
      | ((selector: TeachingTableModelSelector) => TeachingTableModelSelector)
      | undefined
  ) {
    return this.__child('teachingTable', TeachingTableModelSelector, builder)
  }
}
export function selectFromTeachingTableGame() {
  return new TeachingTableGameModelSelector()
}

export const teachingTableGameModelPrimitives =
  selectFromTeachingTableGame().channelName.isFull.openSeats.scheduleId.scheduleTime.status.tableAmount.winners
